var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (1==1)?_c('div',{attrs:{"id":"timeTravel"}},[_c('button',{on:{"click":_vm.undo}},[_vm._v("Undo")])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-535a31e9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/editor/TimeTravel.vue
// module id = QB3H
// module chunks = 1